module.exports = __webpack_public_path__ + "static/media/transandina_onde_1.884037dd.jpg";